// src/components/ClaimDetail/ClaimTabs.jsx
//
// Barra de secciones de la ficha del reclamo. Cada botón muestra una sección
// (aria-pressed) en vez de desplazar una página larga. La lista de secciones
// disponibles depende de si el reclamo tiene cheques y de si el usuario puede
// editarlo (ver sectionsFor).
import React from 'react';

// [id, icono, español, inglés]
export const CLAIM_SECTIONS = [
  ['claim-steps', 'fa-route', 'Pasos', 'Steps'],
  ['claim-checks', 'fa-money-check-dollar', 'Cheques', 'Checks'],
  ['claim-payments', 'fa-sack-dollar', 'Cobro CSR', 'CSR collection'],
  ['claim-schedule', 'fa-regular fa-calendar', 'Agenda', 'Schedule'],
  ['claim-documents', 'fa-folder-open', 'Documentos generados', 'Generated documents'],
  ['claim-files', 'fa-paperclip', 'Archivos adjuntos', 'Attached files'],
  ['claim-notes', 'fa-note-sticky', 'Casos y notas', 'Cases & notes'],
  ['claim-details', 'fa-circle-info', 'Datos', 'Details']
];

// Cobro CSR solo existe cuando hay cheques del modelo anterior y solo lo ve quien
// puede ver lo que gana CSR (Super Admin y P.A Admin); los documentos generados
// solo los ve quien puede editar el reclamo.
export const sectionsFor = ({ hasChecks, canEdit, canSeeEarnings = true }) => CLAIM_SECTIONS
  .filter(([id]) => (id !== 'claim-payments' || (hasChecks && canSeeEarnings)) && (id !== 'claim-documents' || canEdit));

const ClaimTabs = ({ language, sections, activeSection, onSectionChange }) => (
  <nav className="claim-jump" aria-label={language === 'es' ? 'Secciones del reclamo' : 'Claim sections'}>
    {sections.map(([id, icon, es, en]) => (
      <button key={id} type="button" aria-pressed={activeSection === id} onClick={() => onSectionChange(id)}>
        <i className={icon.includes(' ') ? icon : `fa-solid ${icon}`} aria-hidden="true"></i> {language === 'es' ? es : en}
      </button>
    ))}
  </nav>
);

export default ClaimTabs;
